import React from "react";
import { Link } from "react-router-dom";
import styles from "./styles.module.scss";
import { useCurrentAccountQuery } from "../../../../../api/queries/useAccountQuery";
import { Inbox } from "./shared/Inbox";
import { PERMISSIONS, PLAN_CODES } from "../../../../../consts/api";
import { usePermission } from "../../../../../hooks/usePermission";
import { CLIENTS_ROUTES } from "../../../../../consts/routes";
import { AppTranslation } from "../../../../../i18n/useAppTranslation";

export const Actions = ({
  patientId,
  getClientDocuments,
  getOldClientDocuments,
  getPaymentHistory,
  getCustomerNotes,
  createAppointment,
  showMembershipModal,
  showTreatmentModal,
  openClientWallet,
  getMedicalHistory,
  exportProcedures,
  upcomingAppointmentsCount,
  getUpcomingAppointments,
}) => {
  const { data: account } = useCurrentAccountQuery();

  const canViewPatients = usePermission(
    PERMISSIONS.patientManagement.viewPatients,
  );
  const canViewCustomerNotes = usePermission(
    PERMISSIONS.patientManagement.viewCustomerNotes,
  );
  const canCreateAppointment = usePermission(
    PERMISSIONS.appointments.createAppointment,
  );
  const canManageMedicalHistory = usePermission(
    PERMISSIONS.patientManagement.manageMedicalHistory,
  );
  const canViewAppointments = usePermission(
    PERMISSIONS.appointments.viewAppointments,
  );
  const canViewDocuments = usePermission(
    PERMISSIONS.patientManagement.viewDocuments,
  );
  const canExportProcedures = usePermission(
    PERMISSIONS.patientManagement.exportProcedures,
  );

  return !!account?.preferences?.isTouchMd &&
    account?.subscriptionPlan == PLAN_CODES.booking ? (
    <div className={styles.root}>
      {canViewPatients.permitted && (
        <a onClick={getClientDocuments} className="blue-btn pull-right">
          {"Documents"}
        </a>
      )}
      {canViewPatients.permitted && (
        <a onClick={getOldClientDocuments} className="blue-btn pull-right">
          {"Old Documents"}
        </a>
      )}
      {account?.isPosEnabled && (
        <a onClick={getPaymentHistory} className="blue-btn pull-right">
          {"Payment History"}
        </a>
      )}
      {canViewCustomerNotes.permitted && (
        <a className="blue-btn pull-right" onClick={getCustomerNotes}>
          {"Customer Notes"}
        </a>
      )}
    </div>
  ) : (
    <div className={styles.root}>
      <div className={styles.left}>
        {account?.isInboxEnabled && <Inbox patientId={patientId} />}
        {account?.globalSettings?.isEfaxEnabled && (
          <Link
            to={CLIENTS_ROUTES.eFax(patientId)}
            className={`blue-btn pull-right ${styles.navigationLink}`}
          >
            {"eFax Orders"}
          </Link>
        )}
        <Link
          className={`blue-btn pull-right ${styles.navigationLink}`}
          to={CLIENTS_ROUTES.vitals(patientId)}
        >
          {"Vitals"}
        </Link>
        {canCreateAppointment.permitted && (
          <a onClick={createAppointment} className="blue-btn pull-right">
            {"Create Appointment"}
          </a>
        )}
        <a onClick={showMembershipModal} className={"blue-btn pull-right"}>
          {"Membership Plan"}
        </a>
        {account?.isPosEnabled && (
          <a onClick={showTreatmentModal} className="blue-btn pull-right">
            {"Treatment Plan"}
          </a>
        )}
        {account?.isPosEnabled && (
          <a onClick={openClientWallet} className="blue-btn pull-right">
            <AppTranslation.Clients path="profile.wallet" />
          </a>
        )}
        {canManageMedicalHistory.permitted && (
          <a className="blue-btn pull-right" onClick={getMedicalHistory}>
            {"Medical History"}
          </a>
        )}
        {canViewCustomerNotes.permitted && (
          <a className="blue-btn pull-right" onClick={getCustomerNotes}>
            {"Customer Notes"}
          </a>
        )}
      </div>
      {(canViewCustomerNotes.permitted ||
        canViewAppointments.permitted ||
        canManageMedicalHistory.permitted ||
        canViewDocuments.permitted) && (
        <div className="dropdown more-info-profile-dropdown">
          <button
            className="line-btn pull-right"
            type="button"
            id="dropdownMenu1"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="true"
          >
            {"More Info "}
            <i className="fas fa-angle-down"></i>
          </button>
          <ul className="dropdown-menu" aria-labelledby="dropdownMenu1">
            {canExportProcedures.permitted && (
              <li>
                <a
                  className="header-unselect-btn modal-link"
                  onClick={exportProcedures}
                >
                  {"Export Procedures"}
                </a>
              </li>
            )}
            {canViewAppointments.permitted && (
              <li>
                <a
                  onClick={getUpcomingAppointments}
                  className="header-unselect-btn setting"
                >
                  {"Upcoming Appointments "}
                  {"(" + upcomingAppointmentsCount + ")"}
                </a>
              </li>
            )}
            {canViewPatients.permitted && (
              <li>
                <a
                  onClick={getClientDocuments}
                  className="header-unselect-btn setting modal-link"
                >
                  {"Documents"}
                </a>
              </li>
            )}
            {canViewPatients.permitted && (
              <li>
                <a
                  onClick={getOldClientDocuments}
                  className="header-unselect-btn setting modal-link"
                >
                  {"Old Documents"}
                </a>
              </li>
            )}
            {account?.isPosEnabled && (
              <li>
                <a
                  onClick={getPaymentHistory}
                  className="header-unselect-btn setting modal-link"
                >
                  {"Payment History"}
                </a>
              </li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};
